<template>
    <div v-if="loading" class="loading-container">
        <b-row class="justify-content-center">
            <b-col cols="12" class="text-center">
                <atom-spinner
                    :animation-duration="1000"
                    :size="60"
                    color="#ff1d5e"
                    class="my-4"
                />
            </b-col>
        </b-row>
    </div>
    <div v-else class="animated fadeIn">
        <component-header
            title="Offices"
            @search-query="onSearch"
            :isLoading="loading"
            @reload-data="getOfficeList"
            @create-press="createOffice"
            createButtonText="Create Office"
        />
        <b-card class="card-wrap" border-variant="info">
            <div>
                <b-table
                    class="table-border-radius"
                    responsive
                    :fields="partnerColumns"
                    :items="partners"
                    :dark="dark"
                    :hover="hover"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="filter"
                    @filtered="onFiltered"
                    thead-class="header"
                    :striped="striped"
                    :bordered="bordered"
                    :small="small"
                    :fixed="fixed"
                    show-empty
                    ref="partners"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                >
                    <template slot="cell(name)" slot-scope="data">
                        <div class="table-row">{{ data.userName }}</div>
                    </template>
                    <template slot="cell(action)" slot-scope="data">
                        <ActionButtonGroup
                            :showView="true"
                            :showEdit="true"
                            :showDelete="true"
                            @view="viewOffice(data.item)"
                            @edit="editOffice(data.item)"
                            @delete="deleteOffice(data.item)"
                        />
                    </template>
                </b-table>
            </div>
            <div class="pagination-wrapper">
                <b-pagination
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="totalRows"
                    aria-controls="my-table"
                    prev-text="Prev"
                    next-text="Next"
                    hide-goto-end-buttons
                ></b-pagination>
            </div>
        </b-card>
    </div>
</template>
<script>
import ebButton from "@/components/FormElements/Button";
import ComponentHeader from "@/components/componentNewHeader";
import ActionButtonGroup from "@/components/Common/ActionButtonGroup.vue";
import { AtomSpinner } from "epic-spinners";
export default {
    name: "viewattribute",
    components: { ebButton, AtomSpinner, ComponentHeader, ActionButtonGroup },
    data() {
        return {
            filter: "",
            filterCount: null,
            loading: false,
            hover: true,
            currentPage: 1,
            perPage: 10,
            striped: false,
            bordered: true,
            small: false,
            fixed: false,
            dark: false,
            partner: {},
            sortBy: "createdAt",
            sortDesc: true,
            partnerColumns: [
                { key: "userName", sortable: true },
                { key: "email" },
                { key: "phone" },
                { key: "action" },
            ],
        };
    },
    computed: {
        totalRows() {
            return this.filterCount !== null
                ? this.filterCount
                : this.partners.length;
        },
        partners() {
            let data = this.$store.getters["partner/GetPartnerList"];
            let partnerList = [];
            if (Array.isArray(data) && data.length > 0) {
                data.map((obj) => {
                    let arrayObj = {
                        _id: obj._id,
                        userName: obj.authentication.userName,
                        email: obj.authentication.email,
                        phone: obj.authentication.phone,
                        ...obj,
                    };
                    partnerList.push(arrayObj);
                });
                return partnerList;
            } else {
                return [];
            }
        },
    },
    watch: {
        partners: {
            handler(newVal) {
                if (this.filterCount === null && newVal && newVal.length > 0) {
                    this.filterCount = newVal.length;
                }
            },
            immediate: true,
        },
    },
    methods: {
        onSearch(val) {
            this.filter = val;
            this.currentPage = 1;
        },
        onFiltered(filteredItems) {
            this.filterCount = filteredItems ? filteredItems.length : 0;
            this.currentPage = 1;
        },
        viewOffice(data) {
            this.$store.dispatch("partner/editPartnerData", data);
            this.$router.push(`/office-management/view/${data._id}`);
        },
        editOffice(data) {
            this.$store.dispatch("partner/editPartnerData", data);
            this.$router.push(`/office-management/edit/${data._id}`);
        },
        createOffice() {
            this.$router.push("/office-management/create");
        },
        async getOfficeList() {
            this.loading = true;
            await this.$store.dispatch("partner/officeList", {type:"OFFICE"}).then((data) => {
                if (data.message) {
                    this.$toasted.error(data.message);
                    this.loading = false;
                }
                this.loading = false;
            });
        },
        async deleteOffice(data) {
            await this.$swal({
                title: "Are you sure?",
                text: "You can't revert this action!!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Delete",
                cancelButtonColor: "#d33",
                reverseButtons: true,
            }).then((result) => {
                if (result.value) {
                    this.isLoading = true;
                    this.$store
                        .dispatch("partner/deletePartner", data._id)
                        .then((result) => {
                            this.$toasted.success("User Deleted Successfully");
                            this.getOfficeList();
                        });
                    this.isLoading = false;
                }
            });
        },
    },
    async mounted() {
        this.loading = true;
        let data = this.$store.getters["partner/GetPartnerList"];
        await this.getOfficeList();
        this.$store.dispatch("partner/editPartnerData", null);
        this.loading = false;
    },
};
</script>

<style lang="sass" scoped>
.edit
  color: white !important
.text-center
  text-align: center
.form-div label
  margin-top: 8px
.action-btn-group
  display: flex
  align-items: center

  .button-circle
    margin-right: 0.5rem

    &:last-child
      margin-right: 0


@media (max-width: 576px)
  .action-btn-group
    flex-direction: column
    align-items: center

    .button-circle
      margin-right: 0
      margin-bottom: 0.5rem

      &:last-child
        margin-bottom: 0

.loading-container
  min-height: 200px
  display: flex
  align-items: center
  justify-content: center

.table-border-radius
  border-radius: 12px

.btn-orange
  background: #fe7b08
  border: #fe7b08

.pagination-wrapper
  float: right
  margin-top: 1rem

@media (max-width: 576px)
  .pagination-wrapper
    float: none
    text-align: center
</style>
<style scoped>
.action-btn-group {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 6px; /* spacing between buttons */
    flex-wrap: nowrap; /* prevents stacking on small screens */
}

.action-btn-group .btn {
    flex-shrink: 0; /* prevents buttons from shrinking */
}
</style>
